import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import * as i1 from 'primeng/tabview';
import * as i2 from 'add-education-details';
import { AddEducationDetailsModule } from 'add-education-details';
import * as i3 from 'edit-training-details';
import { EditTrainingDetailsModule } from 'edit-training-details';
import * as i4 from 'edit-license-details';
import { EditLicenseDetailsModule } from 'edit-license-details';
import { PrimengLibraryModule } from 'primeng-library';

class EditEducationDetailsTabService {
    constructor() { }
}
EditEducationDetailsTabService.ɵfac = function EditEducationDetailsTabService_Factory(t) { return new (t || EditEducationDetailsTabService)(); };
EditEducationDetailsTabService.ɵprov = i0.ɵɵdefineInjectable({ token: EditEducationDetailsTabService, factory: EditEducationDetailsTabService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EditEducationDetailsTabService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class EditEducationDetailsTabComponent {
    constructor() { }
    ngOnInit() {
    }
    ngOnChanges(changes) {
        if (changes.editEducationData.currentValue) {
            this.inputData = changes.editEducationData.currentValue;
        }
    }
}
EditEducationDetailsTabComponent.ɵfac = function EditEducationDetailsTabComponent_Factory(t) { return new (t || EditEducationDetailsTabComponent)(); };
EditEducationDetailsTabComponent.ɵcmp = i0.ɵɵdefineComponent({ type: EditEducationDetailsTabComponent, selectors: [["edit-education-details-tab"]], inputs: { editEducationData: "editEducationData" }, features: [i0.ɵɵNgOnChangesFeature], decls: 7, vars: 3, consts: [["header", "Education"], [3, "editEduData"], ["header", "Trainings"], [3, "editTrainingData"], ["header", "Licenses or Certifications"], [3, "editLicenceData"]], template: function EditEducationDetailsTabComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "p-tabView");
        i0.ɵɵelementStart(1, "p-tabPanel", 0);
        i0.ɵɵelement(2, "add-education-details", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "p-tabPanel", 2);
        i0.ɵɵelement(4, "edit-training-details", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "p-tabPanel", 4);
        i0.ɵɵelement(6, "edit-license-details", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("editEduData", ctx.inputData);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("editTrainingData", ctx.inputData);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("editLicenceData", ctx.inputData);
    } }, directives: [i1.TabView, i1.TabPanel, i2.AddEducationDetailsComponent, i3.EditTrainingDetailsComponent, i4.EditLicenseDetailsComponent], styles: [".btn-group[_ngcontent-%COMP%] > .childBtn[_ngcontent-%COMP%]{padding:15px;border:.25px solid #dedede;color:#a3a6b4;background-color:#fff;font-size:85%}.childBtn.firstBtn[_ngcontent-%COMP%]{border-radius:30px 0 0 30px!important;border-right:-1px solid #dedede!important;border-left:0!important}.childBtn.lastBtn[_ngcontent-%COMP%]{border-bottom-right-radius:30px!important;border-top-right-radius:30px!important;border-right:0!important;border-left:-1px solid #dedede!important}.btn-group[_ngcontent-%COMP%] > .activebtn[_ngcontent-%COMP%]{background-color:#19a0da;color:#fff}.route-link[_ngcontent-%COMP%]{width:270px;height:50px;text-decoration:none!important}.route-link[_ngcontent-%COMP%], .route-link-2[_ngcontent-%COMP%]{display:block}.childBtn[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{color:#a3a6b4;padding-left:15px;padding-right:10px}.activebtn[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{color:#fff}[_nghost-%COMP%]     .p-tabview{border:0;background:#fff 0 0 no-repeat padding-box!important}[_nghost-%COMP%]     .p-tabview .p-tabview-nav{flex-wrap:nowrap!important;width:60%;background:#f5f7f7 0 0 no-repeat padding-box;margin:0 auto}[_nghost-%COMP%]     .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link{color:#fff!important;background-color:#19a0da!important}[_nghost-%COMP%]     .p-tabview .p-tabview-nav li .p-tabview-nav-link{border:solid #dee2e6;border-width:0 0 2px;background:#f5f7f7 0 0 no-repeat padding-box;color:#6a626e!important;padding:1rem;height:50px;text-align:center;font-style:normal;font-size:15px;font-weight:600;font-family:Source Sans Pro;letter-spacing:0;color:#4a4a4a;opacity:1}[_nghost-%COMP%]     .p-tabview .p-tabview-panel{padding-top:40px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EditEducationDetailsTabComponent, [{
        type: Component,
        args: [{
                selector: 'edit-education-details-tab',
                templateUrl: './edit-education-details-tab.component.html',
                styleUrls: ['./edit-education-details-tab.component.scss']
            }]
    }], function () { return []; }, { editEducationData: [{
            type: Input
        }] }); })();

class EditEducationDetailsTabModule {
}
EditEducationDetailsTabModule.ɵfac = function EditEducationDetailsTabModule_Factory(t) { return new (t || EditEducationDetailsTabModule)(); };
EditEducationDetailsTabModule.ɵmod = i0.ɵɵdefineNgModule({ type: EditEducationDetailsTabModule });
EditEducationDetailsTabModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            AddEducationDetailsModule,
            EditLicenseDetailsModule,
            EditTrainingDetailsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(EditEducationDetailsTabModule, { declarations: [EditEducationDetailsTabComponent], imports: [PrimengLibraryModule,
        AddEducationDetailsModule,
        EditLicenseDetailsModule,
        EditTrainingDetailsModule], exports: [EditEducationDetailsTabComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EditEducationDetailsTabModule, [{
        type: NgModule,
        args: [{
                declarations: [EditEducationDetailsTabComponent],
                imports: [
                    PrimengLibraryModule,
                    AddEducationDetailsModule,
                    EditLicenseDetailsModule,
                    EditTrainingDetailsModule
                ],
                exports: [EditEducationDetailsTabComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of edit-education-details-tab
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EditEducationDetailsTabComponent, EditEducationDetailsTabModule, EditEducationDetailsTabService };
//# sourceMappingURL=edit-education-details-tab.js.map
